export class NavaidStatus{

  constructor(id : string, name : string, type : string, status : string) {
    this.identification = id;
    this.name = name;
    this.status = status;
    this.type = type;
  }

  identification : string;
  name : string;
  type : string;
  status : string;
}
